// @ts-nocheck
import React from 'react';
import { useTable, useSortBy } from 'react-table';
import styled from 'styled-components';

export const StyledTable = styled.div`
  margin-top: ${props => (props.negativeMargin ? -20 : -5)}px;
  .psp-table {
    text-align: center;
    width: 100%;
    border-spacing: 1px;
    border: 1px solid ${p => p.theme.colour.lightSilver};
  }

  .psp-table-tr {
    td {
      padding: 0.3rem;
      border-right: 1px solid ${p => p.theme.colour.lightSilver};
    }
    background-color: ${p => p.theme.colour.darkSilver};
    :last-child {
      td {
        border-bottom: 0;
      }
    }
  }

  .psp-table-tr:nth-child(odd) {
    background-color: ${p => p.theme.colour.silver};
  }

  .psp-table-th {
    color: ${p => p.theme.colour.white};
    font-weight: bold;
    border-right: 1px solid ${p => p.theme.colour.lightSilver};
    background-color: ${p => p.theme.colour.mediumGrey};
  }

  .psp-table-th,
  .psp-table-td {
    margin: 0;
    padding: 0.5rem;
    :last-child {
      border-right: 0;
    }
  }

  .psp-table-sublabel {
    font-size: 11px;
    margin-bottom: 2px;
  }
`;

export const DataColumns = [
  {
    accessor: 'label',
  },
  {
    accessor: 'value',
  },
];

interface TableProps {
  columns: any;
  data: any;
  sorting?: boolean;
  negativeMargin?: boolean;
  headless?: boolean;
  tableName?: string;
}

const Table: React.FC<TableProps> = ({ columns, data, negativeMargin = false, sorting = true, headless = false, tableName }) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
    {
      columns,
      data,
    },
    sorting ? useSortBy : undefined
  );

  // Render the UI for your table
  return (
    <StyledTable negativeMargin={negativeMargin}>
      <table className="psp-table" {...getTableProps()}>
        {!headless && (
          <thead>
            {headerGroups.map(headerGroup => {
              const { key: headerGroupKey, ...headerGroupProps } = headerGroup.getHeaderGroupProps();
              return (
                <tr key={headerGroupKey} className="psp-table-tr" {...headerGroupProps}>
                  {headerGroup.headers.map(column => {
                    const { key: columnKey, ...columnProps } = column.getHeaderProps({
                      style: {
                        minWidth: column.minWidth,
                        width: column.width,
                        maxWidth: column.maxWidth,
                      },
                    });
                    return (
                      <th key={columnKey} className="psp-table-th" {...columnProps}>
                        {column.render('Header')}
                        <span>{column.isSorted ? (column.isSortedDesc ? ' ⇂' : ' ↿') : ''}</span>
                      </th>
                    );
                  })}
                </tr>
              );
            })}
          </thead>
        )}
        <tbody {...getTableBodyProps()}>
          {!rows.length && (
            <tr className="psp-table-tr">
              <td colSpan={columns.length} data="psp-table-td">
                No data.
              </td>
            </tr>
          )}
          {rows.map((row: any, i: any) => {
            prepareRow(row);
            const { key: rowKey, ...rowProps } = row.getRowProps();
            return (
              <tr key={rowKey} className="psp-table-tr" {...rowProps}>
                {tableName === "poolOutbound" && (
                  <td key={`row-no-${i}`} className="psp-table-td-no">{ i + 1 }</td>
                )}
                {row.cells.map((cell: any, i: any) => {
                  const headlessLabel = headless && i === 0;
                  if (tableName === "poolOutbound" && i === 0) {
                    return null;
                  }
                  const { key: cellKey, ...cellProps } = cell.getCellProps();
                  return (
                    <td
                      key={cellKey}
                      data="psp-table-td"
                      style={{ width: headlessLabel ? '40%' : undefined }}
                      {...cellProps}
                    >
                      {cell.render('Cell')}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </StyledTable>
  );
};

export default Table;
